import { countryValidators } from './hooks/country_validators';

export const removeSegment = (promotion_id, login_ids, segment_id, cb) => {
	let info = {};
	info.ids = login_ids;
	info.segment_id = segment_id;
	$.post(`/users/apply_bulk/remove_segment/${promotion_id}`, info, (response) => {
		if(cb != undefined) cb();
	});
};

export const getSegments = (cb, promotion_id) => {
	const data = {};
	if(promotion_id != undefined) (data.promotion_id = promotion_id)
	$.get('/accounts/segments', data, (response) => {
		cb(response);
	}, 'JSON');
};

export const promoteSegment = (segment_id, type, cb) => {
	$.post(`/accounts/promotesegment/${segment_id}/${type}`, (response) => {
		if(cb != undefined) cb(response);
	}, 'JSON');
};

export const deleteSegment = (segment_id, confirm = false, cb) => {
	$.post(`/accounts/deletesegment`,{ segment_id, confirm }, (response) => {
		if(cb != undefined) cb(response);
	}, 'JSON');
};

export const getDocuments = (cb, promotion_id) => {
	const data = {};
	if(promotion_id != undefined) (data.promotion_id = promotion_id)
	$.get('/accounts/segments', data, (response) => {
		cb(response);
	}, 'JSON');
};

export const getDocumentValidators = async (cb_documents,cb_countries) => {
	let _docs = []
	let _countries = [];
	
	const country_validators = await countryValidators();

	//.concat(Object.keys(window.countries).map( c => ({k:c,v:window.countries[c]})))
	const validators = {};
	const countriesWithValidators = Object.keys(country_validators);

	countriesWithValidators.forEach((country) => {
		  const validatorsForCountry = Object.keys(country_validators[country]);
		if (!validators[country]) {
			validators[country] = {};
		}
		const _country = window.countries[country] ?? null
		validatorsForCountry.forEach((validator) => {
			validators[country][validator] = country_validators[country][validator]; // Corregimos la asignación del validador
			let name = `${(country_validators[country][validator].localName ? country_validators[country][validator].localName : country_validators[country][validator].name)}`;
			if(name)name += ' - ';
			name += `${(country_validators[country][validator].abbreviation) ? country_validators[country][validator].abbreviation : ''}`;
			name += `${_country ? ' ('+_country+')':''}`;
			const key = `${country}.${validator}`;
			_docs.push({k:key,v:name, search_selector:country})
		});
		if(_countries[country]==undefined && _country)_countries[country] = _country;
	});

	if(cb_documents!=undefined)cb_documents(_docs);
	if(cb_countries!=undefined)cb_countries(Object.keys(_countries).map( c => ({k:c,v:_countries[c]})));

}